module.exports = __webpack_public_path__ + "static/img/sexy slippers.e3d6b30.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/card/sexy slippers.jpg
// module id = P7Wd
// module chunks = 1